<ng-container *ngIf="performanceData; else noData">
<div class="main">
  <div class="container-fluid">
    <div class="header">
      <span><h4 class="site_stats">SITE STATS</h4></span>
      <span>
        <a [class.disabled-link]="!siteAccName && !siteUnitId" (click)="uptime_csv($event)">
            <i class="material-icons" matTooltip="Download CSV" style="position: relative;top: 8px;cursor: pointer">file_download</i>
        </a>
    </span>
          </div>
    <br />
  </div>
  <div id="power-container">
    <div id="power"></div>
    <div id="power2"></div>
    <div id="power1"></div>
  </div>
  <div id="chart-container" class="chart">
    <h4 class="bar-graph">DAILY SITE PERFORMANCE</h4>
    <canvas baseChart
            [datasets]="barChartData"
            [labels]="barChartLabels"
            [options]="barChartOptions"
            [legend]="barChartLegend"
            [chartType]="barChartType"
            [ngStyle]="{'max-height':  barChartLength <= 31 ? '50vh' : '50vh','height':'100%'}"
            [ngClass]="{'width-200':barChartLength <= 50,'width-500':barChartLength>50 && barChartLength <= 100,'width-1000':barChartLength > 100}"
            >
    </canvas>
  </div>
</div>
</ng-container>
<ng-template #noData>
  <span class="no-data-cell">
  <b>NO DATA AVAILABLE</b>
</span>
</ng-template>